import { layout } from '../../App.routing'

export const propertySegment = layout.component({
    type: 'lima',
    props: {
        verticalSpacing: 'xl',
        fixedRatios: ['16:9'],
        intermediateColumns: 2,
        finalColumns: 4,
        teaserMode: 'hidden',
        hideByline: false,
        hasBackground: true,

        cardLayout: [
            ['teaserWithBackground'],
            ['teaserWithBackground'],
            [
                {
                    type: 'landscape',
                    format: 'landscape-smTeaser-mdNoTeaser',
                },
                {
                    type: 'landscape',
                    format: 'landscape-smTeaser-mdNoTeaser',
                },
                {
                    type: 'landscape',
                    format: 'landscape-smTeaser-mdNoTeaser',
                },
            ],
            ['teaserWithBackground'],
        ],
        cardOrientation: { type: 'Landscape-Portrait' },
        sectionHeader: {
            heading: 'Property',
            section: 'business',
            headingUrl: '/business/property',
        },
        dataDefinitionArgs: {
            type: 'curation',
            name: 'property',
            offset: 0,
            pageSize: 6,
        },
    },
})
